import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

// 抑制 Vue Router 3 的 NavigationDuplicated / NavigationAborted 警告
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name === 'NavigationDuplicated' || err.name === 'NavigationAborted') return
    return Promise.reject(err)
  })
}
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name === 'NavigationDuplicated' || err.name === 'NavigationAborted') return
    return Promise.reject(err)
  })
}

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/invite',
    name: 'Invite',
    component: () => import('@/views/Invite.vue')
  },
  {
    path: '/trade',
    name: 'Trade',
    component: () => import('@/views/Trade.vue')
  },
  {
    path: '/trade/:symbol',
    name: 'TradeSymbol',
    component: () => import('@/views/Trade.vue')
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('@/views/Account.vue'),
    redirect: '/account/overview',
    children: [
      { path: 'overview', name: 'AccountOverview', component: () => import('@/views/account/Overview.vue') },
      { path: 'exchange', name: 'AccountExchange', component: () => import('@/views/account/Exchange.vue') },
      { path: 'deposit', name: 'AccountDeposit', component: () => import('@/views/account/Deposit.vue') },
      { path: 'withdraw', name: 'AccountWithdraw', component: () => import('@/views/account/Withdraw.vue') },
      { path: 'fund', name: 'AccountFund', component: () => import('@/views/account/Fund.vue') },
      { path: 'invite', name: 'AccountInvite', component: () => import('@/views/account/InvitePanel.vue') },
      { path: 'notice', name: 'AccountNotice', component: () => import('@/views/account/NoticePanel.vue') },
      { path: 'profile', name: 'AccountProfile', component: () => import('@/views/account/Profile.vue') },
      { path: 'kyc', name: 'AccountKyc', component: () => import('@/views/account/Kyc.vue') },
      { path: 'advanced-kyc', name: 'AccountAdvancedKyc', component: () => import('@/views/account/AdvancedKyc.vue') },
      { path: 'security', name: 'AccountSecurity', component: () => import('@/views/account/Security.vue') },
      { path: 'settings', name: 'AccountSettings', component: () => import('@/views/account/Settings.vue') }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// Navigation guard — 未登录访问非首页时弹出登录弹窗
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['user/isLoggedIn']

  // 捕获邀请码：无论是否登录，只要 URL 中有 inviteCode 就存入 localStorage
  // 这样新用户点击邀请链接后，即使被重定向到首页，邀请码也不会丢失
  const inviteCode = to.query.inviteCode || to.query.invitecode
  if (inviteCode) {
    localStorage.setItem('ftx_invite_code', inviteCode)
  }

  // 未登录时，除首页外所有页面均弹出登录弹窗
  if (!isLoggedIn && to.name !== 'Home') {
    store.commit('user/SET_REDIRECT_PATH', to.fullPath)
    // 延迟触发登录弹窗，确保跳转完成
    setTimeout(() => store.commit('user/SET_SHOW_LOGIN', true), 100)
    next('/home')
    return
  }

  next()
})

export default router
